

import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Chip,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  Tooltip,
  Avatar,
  TablePagination,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Snackbar,
  Alert,
  Collapse,
  CardContent,
  Divider,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import {
  CheckCircle as AcceptIcon,
  Cancel as RejectIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  Person as PersonIcon,
  DirectionsBus as BusIcon,
  Phone as PhoneIcon,
  AccessTime as TimeIcon,
  AccessTime as AccessTimeIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  LocationOn as LocationOnIcon,
} from "@mui/icons-material";
import { format } from "date-fns";
import UserApprovalServices from "../../services/externalServices/trackingservices/userApprovalServices";
import { getOwnerIdFromLocalStorage } from "../../utils/auth";
const UserApprovalScreen = () => {
  const [approvals, setApprovals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedApproval, setSelectedApproval] = useState(null);
  const [actionType, setActionType] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [bulkActionDialog, setBulkActionDialog] = useState(false);
  const [expandedUsers, setExpandedUsers] = useState({});
  const [rejectReason, setRejectReason] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [statusFilter, setStatusFilter] = useState("ALL");
  
  // NEW: Selection states
  const [selectedUsers, setSelectedUsers] = useState(new Set());
  const [selectAll, setSelectAll] = useState(false);
  const [bulkApprovalDialog, setBulkApprovalDialog] = useState(false);
  const [ownerId, setOwnerId] = useState(null);
  
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

   useEffect(() => {
      const ownerIdFromStorage = getOwnerIdFromLocalStorage();
      console.log("Owner ID from localStorage:", ownerIdFromStorage);
  
      if (ownerIdFromStorage) {
        setOwnerId(ownerIdFromStorage);
      } else {
        // setError("No owner access found. Please login again.");
        setLoading(false);
      }
    }, []);

  useEffect(() => {
    if (ownerId) {
     fetchApprovals();
    }
    
  }, [ownerId]);

const fetchApprovals = async () => {
  try {
    const res = await UserApprovalServices.getAllUserApprovalsbyOwnerId(ownerId);
    console.log("/owner", res.data);

    const sortedApprovals = (res.data.approvals || []).sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );

    setApprovals(sortedApprovals);
  } catch (err) {
    console.log(err);
  }
  setLoading(false);
};


  // Toggle user expansion
  const toggleUserExpansion = (userId) => {
    setExpandedUsers(prev => ({
      ...prev,
      [userId]: !prev[userId]
    }));
  };

  // Get overall user status
  const getUserOverallStatus = (userApprovals) => {
    const statuses = userApprovals.map(approval => approval.status);
    if (statuses.includes('PENDING')) return 'PENDING';
    if (statuses.every(status => status === 'APPROVED')) return 'APPROVED';
    return 'MIXED';
  };

  // NEW: Handle select all checkbox
  const handleSelectAllChange = (event) => {
    if (event.target.checked) {
      // Select all users that have pending approvals
      const pendingUsers = filteredApprovals
        .filter(userGroup => 
          userGroup.approvals.some(approval => approval.status === 'PENDING')
        )
        .map(userGroup => userGroup.userId);
      
      setSelectedUsers(new Set(pendingUsers));
      setSelectAll(true);
    } else {
      setSelectedUsers(new Set());
      setSelectAll(false);
    }
  };

  // NEW: Handle individual user checkbox
  const handleUserCheckboxChange = (userId) => {
    const newSelected = new Set(selectedUsers);
    if (newSelected.has(userId)) {
      newSelected.delete(userId);
    } else {
      newSelected.add(userId);
    }
    setSelectedUsers(newSelected);
    
    // Update select all checkbox state
    const pendingUsers = filteredApprovals
      .filter(userGroup => 
        userGroup.approvals.some(approval => approval.status === 'PENDING')
      );
    setSelectAll(newSelected.size === pendingUsers.length && pendingUsers.length > 0);
  };

  // NEW: Handle bulk approval of selected users
  const handleBulkApprovalSubmit = () => {
    if (selectedUsers.size === 0) {
      setSnackbar({
        open: true,
        message: "Please select at least one user to approve",
        severity: "warning",
      });
      return;
    }
    setBulkApprovalDialog(true);
  };

  // NEW: Confirm bulk approval of selected users
  // Replace the confirmBulkApprovalSelected function
const confirmBulkApprovalSelected = async () => {
  try {
    const selectedUserIds = Array.from(selectedUsers);

    // Use the new bulk endpoint instead of individual calls
    const response = await UserApprovalServices.bulkUpdateSelectedUserApprovals(
      "686bb1a61fc5b80c2520d59e", // ownerId
      {
        userIds: selectedUserIds,
        approvedBy: "686bb1a61fc5b80c2520d59e", // Replace with actual admin ID
        reason: "Bulk approved via selection"
      }
    );

    if (response.success) {
      setSnackbar({
        open: true,
        message: `✅ Successfully approved ${response.updatedCount} pending requests for ${response.processedUsers.length} selected users! Total routes: ${response.summary?.totalRoutes || 0}`,
        severity: "success",
      });

      // Reset selections and refresh data
      setSelectedUsers(new Set());
      setSelectAll(false);
      fetchApprovals();
    }

  } catch (error) {
    setSnackbar({
      open: true,
      message: "Failed to approve selected users",
      severity: "error",
    });
  } finally {
    setBulkApprovalDialog(false);
  }
};


  // Handle single approval action
  const handleSingleAction = async (approval, action) => {
    setSelectedApproval(approval);
    setActionType(action);
    setDialogOpen(true);
  };

  // Handle bulk action for all user's routes
  const handleBulkAction = async (userGroup, action) => {
    setSelectedUser(userGroup);
    setActionType(action);
    setBulkActionDialog(true);
  };

  // Confirm single action
  const confirmSingleAction = async () => {
    try {
      const response = await UserApprovalServices.updateApprovalStatus(
        selectedApproval._id,
        {
          status: actionType,
          reason: rejectReason
        }
      );

      if (response.success) {
        setSnackbar({
          open: true,
          message: `Approval ${actionType.toLowerCase()}d successfully`,
          severity: "success",
        });
        fetchApprovals();
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        open: true,
        message: "An error occurred",
        severity: "error",
      });
    } finally {
      setDialogOpen(false);
      setRejectReason("");
      setSelectedApproval(null);
      setActionType("");
    }
  };

  // Confirm bulk action
  const confirmBulkAction = async () => {
    try {
      const response = await UserApprovalServices.bulkUpdateUserApprovals({
        userId: selectedUser.userId,
        ownerId: "686bb1a61fc5b80c2520d59e",
        action: actionType,
        reason: rejectReason
      });

      if (response.success) {
        setSnackbar({
          open: true,
          message: `All routes ${actionType.toLowerCase()}d for ${selectedUser.studentName}`,
          severity: "success",
        });
        fetchApprovals();
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: "An error occurred during bulk action",
        severity: "error",
      });
    } finally {
      setBulkActionDialog(false);
      setRejectReason("");
      setSelectedUser(null);
      setActionType("");
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "APPROVED": return "success";
      case "REJECTED": return "error";
      case "PENDING": return "warning";
      case "MIXED": return "info";
      default: return "default";
    }
  };

  // Filter approvals based on status
  const filteredApprovals = approvals?.filter((userGroup) => {
    if (statusFilter === "ALL") return true;
    const userStatus = getUserOverallStatus(userGroup.approvals);
    return statusFilter === userStatus;
  });

  const paginatedApprovals = filteredApprovals?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  // Count pending users for select all
  const pendingUsersCount = filteredApprovals?.filter(userGroup => 
    userGroup.approvals.some(approval => approval.status === 'PENDING')
  ).length || 0;

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom sx={{ mb: 3, fontWeight: "bold" }}>
        User Approval Management
      </Typography>

      {/* Filter Controls with Selection */}
      <Card sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth>
              <InputLabel>Status Filter</InputLabel>
              <Select
                value={statusFilter}
                label="Status Filter"
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <MenuItem value="ALL">All Statuses</MenuItem>
                <MenuItem value="PENDING">Pending</MenuItem>
                <MenuItem value="APPROVED">Approved</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="body2" color="textSecondary">
              Total: {filteredApprovals?.length || 0} users
            </Typography>
          </Grid>

          {/* NEW: Select All Checkbox */}
          <Grid item xs={12} sm={6} md={3}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectAll}
                  onChange={handleSelectAllChange}
                  disabled={pendingUsersCount === 0}
                />
              }
              label={`Select All (${pendingUsersCount} pending)`}
            />
          </Grid>

          {/* NEW: Approve Selected Button */}
          <Grid item xs={12} sm={6} md={3}>
            <Button
              variant="contained"
              color="success"
              startIcon={<AcceptIcon />}
              onClick={handleBulkApprovalSubmit}
              disabled={selectedUsers.size === 0}
            >
              Approve Selected ({selectedUsers.size})
            </Button>
          </Grid>

          {/* Selected count display */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="body2" color="primary" fontWeight="bold">
              Selected: {selectedUsers.size}
            </Typography>
          </Grid>
        </Grid>
      </Card>

      {/* Grouped Approvals */}
      <Box>
        {paginatedApprovals?.map((userGroup) => {
          const overallStatus = getUserOverallStatus(userGroup.approvals);
          const isExpanded = expandedUsers[userGroup.userId];
          const hasPendingApprovals = userGroup.approvals.some(approval => approval.status === 'PENDING');
          const isSelected = selectedUsers.has(userGroup.userId);
          
          return (
            <Card key={userGroup.userId} sx={{ mb: 2, border: isSelected ? '2px solid #1976d2' : 'none' }}>
              <CardContent>
                {/* User Header */}
                <Grid container spacing={2} alignItems="center">
                  {/* NEW: Checkbox for each user */}
                  <Grid item xs={12} md={1}>
                    <Checkbox
                      checked={isSelected}
                      onChange={() => handleUserCheckboxChange(userGroup.userId)}
                      disabled={!hasPendingApprovals}
                      color="primary"
                    />
                  </Grid>

                  <Grid item xs={12} md={2}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Avatar sx={{ bgcolor: "primary.main", width: 32, height: 32 }}>
                        <PersonIcon fontSize="small" />
                      </Avatar>
                      <Box>
                        <Typography variant="body2" fontWeight="bold">
                          {userGroup.studentName}
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          {userGroup.classSection}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={2}>
                    <Box>
                      <Typography variant="body2" fontWeight="medium">
                        {userGroup.requesterName}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        {userGroup.relation} • {userGroup.employeeId}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={2}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                      <PhoneIcon fontSize="small" color="action" />
                      <Typography variant="body2">
                        {userGroup.phone_number}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={2}>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      <Chip
                        label={`${userGroup.approvals.length} Routes`}
                        size="small"
                        variant="outlined"
                        icon={<BusIcon />}
                      />
                      <Chip
                        label={overallStatus}
                        color={getStatusColor(overallStatus)}
                        size="small"
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <Box sx={{ display: "flex", gap: 0.5 }}>
                      {/* Bulk Actions */}
                      {overallStatus === 'PENDING' && (
                        <>
                          <Tooltip title="Approve All Routes">
                            <IconButton
                              size="small"
                              color="success"
                              onClick={() => handleBulkAction(userGroup, "APPROVED")}
                            >
                              <AcceptIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Reject All Routes">
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => handleBulkAction(userGroup, "REJECTED")}
                            >
                              <RejectIcon />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}

                      <Tooltip title="Delete All">
                        <IconButton
                          size="small"
                          color="error"
                          onClick={() => handleBulkAction(userGroup, "DELETE")}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title={isExpanded ? "Collapse" : "Expand Routes"}>
                        <IconButton
                          size="small"
                          onClick={() => toggleUserExpansion(userGroup.userId)}
                        >
                          {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </Grid>
                </Grid>

                {/* Expandable Route Details */}
                <Collapse in={isExpanded}>
                  <Divider sx={{ my: 2 }} />
                  <Typography variant="subtitle2" gutterBottom>
                    Route Details:
                  </Typography>
        
                {/* Route details section with enhanced action buttons */}
                {userGroup.approvals.map((approval, index) => (
                  <Card key={approval._id} variant="outlined" sx={{ mb: 1, p: 2 }}>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12} md={4}>
                        <Typography variant="body2" fontWeight="bold">
                          {approval.vehicleRoutes?.[0]?.route_name || `Route ${index + 1}`}
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          {approval.vehicleRoutes?.[0]?.alias_number && (
                            <>Alias: {approval.vehicleRoutes[0].alias_number}<br /></>
                          )}
                          {approval.vehicleId?.vehicleNumber} - {approval.vehicleId?.vehicleType}
                        </Typography>
                        <Chip 
                          label={approval.vehicleRoutes?.[0]?.routeType || 'N/A'} 
                          size="small" 
                          variant="outlined"
                          color={approval.vehicleRoutes?.[0]?.routeType === 'pickup' ? 'primary' : 'secondary'}
                          sx={{ ml: 1 }}
                        />
                      </Grid>

                      <Grid item xs={12} md={3}>
                        <Typography variant="caption" color="textSecondary">
                          <strong>Stops:</strong> {approval.vehicleRoutes?.[0]?.stops?.length || 0} stops
                        </Typography>
                        <br />
                        {/* Display Pickup Points */}
                        {approval.pickupPoints && approval.pickupPoints.length > 0 && (
                          <>
                            <Typography variant="caption" color="primary" sx={{ fontWeight: 'bold' }}>
                              <LocationOnIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 0.5 }} />
                              Pickup Points:
                            </Typography>
                            {approval.pickupPoints.map((pickup, idx) => (
                              <Typography key={idx} variant="caption" color="textSecondary" sx={{ display: 'block', ml: 2 }}>
                                • {pickup.pickup_name}
                              </Typography>
                            ))}
                          </>
                        )}
                        {(!approval.pickupPoints || approval.pickupPoints.length === 0) && (
                          <Typography variant="caption" color="textSecondary" sx={{ fontStyle: 'italic' }}>
                            No pickup points assigned
                          </Typography>
                        )}
                      </Grid>

                      <Grid item xs={12} md={2}>
                        <Chip
                          label={approval.status}
                          color={getStatusColor(approval.status)}
                          size="small"
                        />
                        <br />
                        {approval.vehicleRoutes?.[0]?.returnRouteId && (
                          <Chip 
                            label="Has Return Route" 
                            size="small" 
                            variant="outlined"
                            color="info"
                            sx={{ mt: 0.5 }}
                          />
                        )}
                      </Grid>

                      <Grid item xs={12} md={2}>
                        <Typography variant="caption" color="textSecondary">
                          {format(new Date(approval.createdAt || userGroup.createdAt), "MMM dd, yyyy")}
                        </Typography>
                      </Grid>

                      {/* ENHANCED ACTION BUTTONS SECTION */}
                      <Grid item xs={12} md={1}>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                          {approval.status === "PENDING" && (
                            <>
                              <Tooltip title="Approve Route">
                                <IconButton
                                  size="small"
                                  color="success"
                                  onClick={() => handleSingleAction(approval, "APPROVED")}
                                  sx={{ border: '1px solid #4caf50' }}
                                >
                                  <AcceptIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </>
                          )}

                          {/* Add Pending Icon for APPROVED status */}
                          {approval.status === "APPROVED" && (
                            <Tooltip title="Set to Pending">
                              <IconButton
                                size="small"
                                color="warning"
                                onClick={() => handleSingleAction(approval, "PENDING")}
                                sx={{ border: '1px solid #ff9800' }}
                              >
                                <AccessTimeIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )}
                          
                          <Tooltip title="Delete Route">
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => handleSingleAction(approval, "DELETE")}
                              sx={{ border: '1px solid #f44336' }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </Grid>
                    </Grid>
                  </Card>
                ))}

                </Collapse>
              </CardContent>
            </Card>
          );
        })}
      </Box>

      {/* Pagination */}
      <TablePagination
        component="div"
        count={filteredApprovals?.length || 0}
        page={page}
        onPageChange={(e, newPage) => setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setPage(0);
        }}
      />

      {/* Single Action Dialog */}
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Confirm Route {
            actionType === "APPROVED" ? "Approval" : 
            actionType === "REJECTED" ? "Rejection" : 
            actionType === "PENDING" ? "Status Change to Pending" :
            "Deletion"
          }
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" gutterBottom>
            Are you sure you want to {
              actionType === "PENDING" ? "set this route back to pending status" : 
              actionType === "APPROVED" ? "approve this specific route approval" :
              `${actionType?.toLowerCase()} this specific route approval`
            }?
          </Typography>
          
          {actionType === "REJECTED" && (
            <TextField
              fullWidth
              multiline
              rows={3}
              label="Reason for rejection (optional)"
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              sx={{ mt: 2 }}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button
            onClick={confirmSingleAction}
            color={actionType === "DELETE" ? "error" : "primary"}
            variant="contained"
          >
            {actionType === "APPROVED" ? "Approve" : 
             actionType === "REJECTED" ? "Reject" : 
             actionType === "PENDING" ? "Set to Pending" :
             "Delete"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Bulk Action Dialog */}
      <Dialog
        open={bulkActionDialog}
        onClose={() => setBulkActionDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Confirm Bulk {
            actionType === "APPROVED" ? "Approval" : 
            actionType === "REJECTED" ? "Rejection" : 
            "Deletion"
          }
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" gutterBottom>
            Are you sure you want to {actionType?.toLowerCase()} ALL routes for{" "}
            <strong>{selectedUser?.studentName}</strong>?
          </Typography>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            This action will affect {selectedUser?.approvals?.length || 0} route(s).
          </Typography>
          
          {actionType === "REJECTED" && (
            <TextField
              fullWidth
              multiline
              rows={3}
              label="Reason for rejection (optional)"
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              sx={{ mt: 2 }}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setBulkActionDialog(false)}>Cancel</Button>
          <Button
            onClick={confirmBulkAction}
            color={actionType === "DELETE" ? "error" : "primary"}
            variant="contained"
          >
            {actionType === "APPROVED" ? "Approve All" : 
             actionType === "REJECTED" ? "Reject All" : 
             "Delete All"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* NEW: Bulk Approval Confirmation Dialog */}
      <Dialog
        open={bulkApprovalDialog}
        onClose={() => setBulkApprovalDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Confirm Bulk Approval</DialogTitle>
        <DialogContent>
          <Typography variant="body1" gutterBottom>
            Are you sure you want to approve ALL pending routes for the selected {selectedUsers.size} users?
          </Typography>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            This will approve all pending approvals for:
          </Typography>
          <Box sx={{ mt: 2, maxHeight: 200, overflow: 'auto' }}>
            {Array.from(selectedUsers).map((userId) => {
              const user = approvals?.find(u => u.userId === userId);
              return (
                <Typography key={userId} variant="body2" sx={{ ml: 2 }}>
                  • {user?.studentName || userId}
                </Typography>
              );
            })}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setBulkApprovalDialog(false)}>Cancel</Button>
          <Button
            onClick={confirmBulkApprovalSelected}
            color="success"
            variant="contained"
          >
            Approve Selected Users
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default UserApprovalScreen;



